export const checksums = {
  "content": "v3.5.0--HwEVeHOfVKaQza0Brfc-m8l9o6sdx09omr9W3lpu4QE",
  "changelog": "v3.5.0--PVgVNlPjUiSkApNLSAPSkhNthGeEVi8pHdkSGHcxTho"
}
export const checksumsStructure = {
  "content": "_kihs04kR02tPE3X6WnwlLduc5GWwXbgehjm8YMhKgM",
  "changelog": "TI9Oq-1urZ2ww1vgJoIYOemIZN0v_9DYFaLqHmx4XvE"
}

export const tables = {
  "content": "_content_content",
  "changelog": "_content_changelog",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "date": "date",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "changelog": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "date": "date",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "version": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}